/**
 * STAGING su DigitalOcean App Platform.
 *
 * App: tangerine-backoffice-web-staging, servita su
 * app-staging.theorangeseed.it. serverAddress e' il backend Laravel nuovo sul
 * cluster DOKS di staging.
 *
 * Lo staging storico continua a vivere su S3 (build-staging-s3) e non viene
 * migrato qui.
 *
 * SPA e API stanno su due sottodomini dello stesso apex: cross-origin (serve
 * CORS lato backend) ma same-site, quindi il cookie di sessione passa con
 * SameSite=Lax e non serve SESSION_SAME_SITE=none.
 */
export const environment = {
	production: true,
	serviceWorker: true,
	serverAddress: 'https://api-staging.theorangeseed.it',
	serverPort: null,
	apiRoutePrefix: '/ajax',
	sessionMaxAge: 24 * 60 * 60,
	BUGSNAG_API_KEY: '2fa607505b9fab8ba5c99a92d3b632eb',
	websocket: {
		enabled: true,
		port: null,
	},
	trenitalia: {
		ar: true
	}
};
